module.exports = {"320903002":"张庄街道","320903003":"盐龙街道","320903004":"潘黄街道","320903005":"滨湖街道","320903006":"北龙港街道","320903007":"中兴街道","320903008":"葛武街道","320903009":"北蒋街道","320903010":"鞍湖街道","320903011":"冈中街道","320903012":"盐渎街道","320903050":"新都街道（城南新区）","320903100":"大纵湖镇","320903102":"楼王镇","320903103":"学富镇","320903105":"尚庄镇","320903108":"秦南镇","320903109":"龙冈镇","320903111":"郭猛镇","320903112":"大冈镇","320903402":"农村经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320903.json
// module id = 905
// module chunks = 0